import { AreaChart, Area, ResponsiveContainer } from "recharts";
import { cn } from "@/lib/utils";

const TINT = {
  primary: "text-primary bg-primary/10",
  green: "text-emerald-600 bg-emerald-500/10",
  amber: "text-amber-600 bg-amber-500/10",
  violet: "text-violet-600 bg-violet-500/10",
  blue: "text-blue-600 bg-blue-500/10",
  red: "text-red-600 bg-red-500/10",
};

const GRADIENT = {
  primary: "from-blue-500 to-blue-600",
  blue: "from-sky-500 to-blue-600",
  green: "from-emerald-500 to-teal-600",
  amber: "from-amber-600 to-orange-700",
  violet: "from-violet-500 to-purple-600",
  red: "from-rose-500 to-red-600",
};

export function KpiCard({ label, value, sub, icon: Icon, accent = "primary", testid, variant = "flat", spark, className }) {
  const hasSpark = spark && spark.length > 1 && spark.some((v) => v > 0);

  if (variant === "hero") {
    return (
      <div data-testid={testid} className={cn(
        "relative overflow-hidden rounded-2xl bg-gradient-to-br p-4 text-white shadow-md",
        GRADIENT[accent] || GRADIENT.primary, hasSpark ? "pb-9" : "", className,
      )}>
        <div className="relative z-10 flex items-center justify-between">
          <span className="text-xs font-medium uppercase tracking-wider text-white/85">{label}</span>
          {Icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/15">
              <Icon className="h-4 w-4" />
            </span>
          )}
        </div>
        <div className="relative z-10 mt-2 font-display text-2xl font-bold tracking-tight">{value}</div>
        {sub && <div className="relative z-10 mt-1 text-xs text-white/85">{sub}</div>}
        {hasSpark && (
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-9 opacity-70">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={spark.map((v) => ({ v }))} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                <defs>
                  <linearGradient id={`spark-${testid}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#fff" stopOpacity={0.55} />
                    <stop offset="100%" stopColor="#fff" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <Area type="monotone" dataKey="v" stroke="#fff" strokeWidth={1.5} fill={`url(#spark-${testid})`} isAnimationActive={false} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    );
  }

  return (
    <div data-testid={testid} className={cn("rounded-2xl border border-border/60 bg-card p-4 shadow-sm transition-shadow hover:shadow-md", className)}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
        {Icon && (
          <span className={cn("flex h-8 w-8 items-center justify-center rounded-lg", TINT[accent])}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className="mt-2 font-display text-2xl font-bold tracking-tight text-foreground">{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
